'use strict';

import angular from 'angular';

export default function () {
    return {
        restrict: 'A',
        template: require('../view/project-tab-questions.html'),
        scope: {
            projectExternalId: '=projectExternalId',
        },
        controller: ['$scope', '$utils', 'ProjectService',
            function ($scope, $utils, ProjectService) {
                $scope.refresh = refresh;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;
                $scope.goToChat = goToChat;

                // инициализация
                init();

                // region Function

                function init() {
                    $scope.loading = true;

                    $scope.questions = [];

                    $scope.columns = [
                        {
                            name: 'Тип',
                            data: 'questionType',
                            type: 'mappedName',
                            mappingFunc: getQuestionTypeDisplayName,
                        },
                        {
                            name: 'Тема',
                            type: 'link',
                            linkCreateFunc: getQuestionNameLinkElement,
                        },
                        {
                            name: 'Эскалировано',
                            data: 'escalationDate',
                            type: 'date',
                        },
                        {
                            name: 'Создано',
                            data: 'createDate',
                            type: 'date',
                        },
                        {
                            name: 'Решено',
                            data: 'resolutionDate',
                            type: 'date',
                        },
                        {
                            name: 'Статус',
                            data: 'status',
                            type: 'mappedName',
                            mappingFunc: getStatusDisplayName,
                        },
                        {
                            name: 'Оценка',
                            data: 'ratingValue',
                            type: 'func',
                            func: getStarRating,
                        },
                    ];

                    $scope.searching = {
                        searchString: null,
                        questionStatus: null,
                    };

                    // тулбокс таблицы
                    $scope.toolbox = {
                        // кнопки на панели управления
                        buttons: {
                            // обновление таблицы
                            refresh: {
                                click: $scope.refresh,
                            },
                        },
                    };

                    // получение данных
                    refresh();
                }

                /**
                 * Обновить данные таблицы
                 */
                function refresh() {
                    $scope.loading = true;
                    ProjectService.api.questions(
                        getListRequestParams(),
                        data => {
                            $scope.questions = data.items;
                            $scope.loading = false;
                        },
                    );
                }

                /**
                 * Получить параметры для запроса списка вопросов
                 */
                function getListRequestParams() {
                    let params = {};

                    if ($scope.searching.searchString) {
                        params.searchString = $scope.searching.searchString;
                    }

                    if ($scope.searching.questionStatus !== 'ALL') {
                        params.status = $scope.searching.questionStatus;
                    }

                    if ($scope.projectExternalId) {
                        params.projectId = $scope.projectExternalId;
                    }

                    params.sortField = 'createDate';
                    params.sortDirection = 'DESC';

                    return params;
                }

                /**
                 * Получить данные для таблицы
                 * @returns {Array|*}
                 */
                function getItems() {
                    return $scope.questions;
                }

                /**
                 * Получить отображение рейтинга
                 * @param ratingValue
                 */
                function getStarRating(ratingValue) {
                    if (angular.isUndefined(ratingValue) || ratingValue === null) {
                        return '';
                    }

                    let maxRatingValue = 5;
                    let ratingBlockWrapper = document.createElement('div');
                    ratingBlockWrapper.className = 'rating-block';

                    let filledStar = document.createElement('i');
                    filledStar.className = 'fa fa-fw fa-star';

                    let unfilledStar = document.createElement('i');
                    unfilledStar.className = 'fa fa-fw fa-star-o';

                    let filledStarCount = ratingValue;
                    let unfilledStarCount = maxRatingValue - filledStarCount;

                    let starElements = [];
                    starElements = starElements.concat(
                        new Array(filledStarCount)
                            .fill({})
                            .map(() => filledStar.cloneNode()),
                    );
                    starElements = starElements.concat(
                        new Array(unfilledStarCount)
                            .fill({})
                            .map(() => unfilledStar.cloneNode()),
                    );

                    starElements.forEach(star => ratingBlockWrapper.appendChild(star));

                    return ratingBlockWrapper.outerHTML;
                }

                /**
                 * Получить имя для отображения статуса вопроса
                 * @param status
                 * @returns {string}
                 */
                function getStatusDisplayName(status) {
                    switch (status) {
                        case 'OPENED':
                            return 'В работе';
                        case 'RESOLVED':
                            return 'Решено';
                        case 'ARCHIVED':
                            return 'Архив';
                    }
                }

                /**
                 * Получить имя для отображения типа вопроса
                 * @param type
                 * @returns {string}
                 */
                function getQuestionTypeDisplayName(type) {
                    switch (type) {
                        case 'QUESTION':
                            return 'Вопрос';
                        case 'PROBLEM':
                            return 'Проблема';
                        case 'CLAIM':
                            return 'Жалоба';
                    }
                }

                /**
                 * Получить html-элемент ссылки на чат
                 * @param question
                 */
                function getQuestionNameLinkElement(question) {
                    let a = document.createElement('a');
                    a.href = getChatLink(question.chatRoomId);
                    a.target = '_blank';
                    a.rel = 'noopener noreferrer';
                    a.innerText = question.name;
                    return a.outerHTML;
                }

                /**
                 * Перейти на страницу чата
                 */
                function goToChat(question) {
                    window.open(getChatLink(question.chatRoomId));
                }

                /**
                 * Получить ссылку на чат
                 * @param chatRoomId
                 * @returns {string}
                 */
                function getChatLink(chatRoomId) {
                    return `${NEW_INVEST_UI_URL}#/chat/${chatRoomId}`;
                }

                // endregion

                // region Watchers

                $scope.$watch('searching.questionStatus', () => {
                    refresh();
                });

                // endregion
            },
        ],
    };
}
